export default{
    lista:{
        method:'get',
        url:'vale/transporte/trabalhador/lista'
    },
    listatrabalhador:{
        method:'get',
        url:'trabalhador/pesquisa{/id}'
    },
    listatomador:{
        method:'get',
        url:'tomador/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'vale/transporte/trabalhador/cadastro'
    },
    delete:{
        method:'delete',
        url:'vale/transporte/trabalhador/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'vale/transporte/trabalhador/editar{/id}'
    },
    update:{
        method:'post',
        url:'vale/transporte/trabalhador/update'
    },
    salariobase:{
        method:'get',
        url:'trabalhador/salario/base{/id}'
    },
}